import { createEntityFilterChip } from 'components/filters/createEntityFilterChip';
import { vendorFieldProps } from './VendorField';

export const VendorFilterChip = createEntityFilterChip('supplier/vendors/', {
  ...vendorFieldProps,
  suggestion: true,
});
